<template>
  <v-container fluid>
    <v-row class="d-flex flex-row">
      <v-col cols="12">
        <FormPageAccount
          :data="account"
          :profiles="profiles"
          :sharedAccess="sharedAccess"
          :reservations="reservations"
          :ticketReservations="ticketReservations"
          :loading="isFormLoading"
          :disabled="isMutationLoading"
          :isNew="!id"
          @submit="formAccountSubmit"
          @delete-account="deleteAccount"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmUserRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
// import { convertToPhone } from '@/configs/numbers'

import FormPageAccount from './form'
import ConfirmationDialog from '@/components/confirmation-dialog'

import createAccount from '@/services/gql/types/Accounts/mutations/createAccount.gql'
import deleteAccount from '@/services/gql/types/Accounts/mutations/deleteAccount.gql'
import updateAccount from '@/services/gql/types/Accounts/mutations/updateAccount.gql'
import accountQuery from '@/services/gql/types/Accounts/queries/account.gql'
import createdByPartner from '@/services/gql/types/CreatedByPartner/queries/createdByPartner.gql'
import invitedPartnerData from '@/services/gql/types/InvitedPartnerData/invitedPartnerData.gql'
import reservationsOfRelations from '@/services/gql/types/OrderBooking/queries/reservationsOfRelations.gql'
import ticketReservationsOfRelations from '@/services/gql/types/TicketReservations/queries/ticketReservationsOfRelations.gql'

export default {
  name: 'PageAccount',
  components: {
    FormPageAccount,
    ConfirmationDialog
  },
  metaInfo () {
    return {
      title: this.id ? 'Редактировать пользователя' : 'Создать пользователя'
    }
  },
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      account: {},
      profiles: null,
      sharedAccess: null,
      reservations: null,
      ticketReservations: null
    }
  },
  computed: {
    isFormLoading () {
      return this.$apollo.queries.account.loading
    },
    isMutationLoading () {
      return this.$async.createAccount.$pending ||
        this.$async.updateAccount.$pending
    },
    getAccountId () {
      return this.account?.id || null
    }
  },
  methods: {
    async formAccountSubmit (accountPayload) {
      if (!this.id) {
        await this.createAccount(accountPayload)
      } else {
        await this.updateAccount(accountPayload)
      }
    },
    async createAccount (data) {
      try {
        await this.$async.createAccount.$perform({ data })
        this.$successMsg('Пользователь создан')
        await this.$router.push({ name: 'page-accounts' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'account.create')
      }
    },
    async deleteAccount () {
      try {
        await this.$refs.confirmUserRemoving.open()
        await this.$async.deleteAccount
          .$perform({ id: this.id })
        this.$successMsg('Пользователь удален')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'account.delete')
      } finally {
        await this.$router.push({ name: 'page-accounts' })
      }
    },
    async updateAccount (data) {
      try {
        await this.$async.updateAccount.$perform({
          id: this.id,
          data
        })
        this.$successMsg('Пользователь изменен')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при редактировании пользователя')
      }
    }
  },
  apollo: {
    account: {
      query: accountQuery,
      fetchPolicy: 'network-only',
      skip () {
        return !this.id
      },
      variables () {
        return {
          where: {
            id: this.id
          }
        }
      }
    },
    profiles: {
      query: createdByPartner,
      fetchPolicy: 'network-only',
      skip () {
        return !this.getAccountId
      },
      variables () {
        return {
          where: {
            accountId: this.getAccountId
          }
        }
      },
      context () {
        return {
          headers: {
            Language: 'ru,en,ko,ja,zh'
          }
        }
      },
      update (data) {
        this.profiles = data.createdByPartner
        return this.profiles
      }
    },
    sharedAccess: {
      query: invitedPartnerData,
      fetchPolicy: 'network-only',
      skip () {
        return !this.getAccountId
      },
      variables () {
        return {
          where: {
            accountId: this.getAccountId
          }
        }
      },
      context () {
        return {
          headers: {
            Language: 'ru,en,ko,ja,zh'
          }
        }
      },
      update (data) {
        this.sharedAccess = data.invitedPartnerData
        return this.sharedAccess
      }
    },
    reservations: {
      query: reservationsOfRelations,
      fetchPolicy: 'network-only',
      skip () {
        return !this.getAccountId
      },
      variables () {
        return {
          where: {
            accountId: this.getAccountId
          }
        }
      },
      context () {
        return {
          headers: {
            Language: 'ru,en,ko,ja,zh'
          }
        }
      }
    },
    ticketReservations: {
      query: ticketReservationsOfRelations,
      fetchPolicy: 'network-only',
      skip () {
        return !this.getAccountId
      },
      variables () {
        return {
          where: {
            accountId: this.getAccountId
          }
        }
      },
      context () {
        return {
          headers: {
            Language: 'ru,en,ko,ja,zh'
          }
        }
      }
    }
  },
  async: {
    createAccount (variables) {
      return this.$apollo.mutate({
        mutation: createAccount,
        variables
      })
    },
    deleteAccount (variables) {
      return this.$apollo.mutate({
        mutation: deleteAccount,
        variables
      })
    },
    updateAccount (variables) {
      return this.$apollo.mutate({
        mutation: updateAccount,
        variables
      })
    }
  }
}
</script>
